import { render } from "./AdminTextarea.vue?vue&type=template&id=21f9ea90"
import script from "./AdminTextarea.vue?vue&type=script&lang=js"
export * from "./AdminTextarea.vue?vue&type=script&lang=js"

import "./AdminTextarea.vue?vue&type=style&index=0&id=21f9ea90&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__